export const GAME_STATUS = {
    ROUND_ACTIVE: "ROUND_ACTIVE"
};

export const CATEGORY_ORDER = [
    "SALES_AND_MARKETING",
    "PRODUCTION",
    "MATERIEL",
    "PERSONNEL",
    "BANK",
    "INCOME_STATEMENT",
];

export const DECISION_ORDER = {
    SALES_AND_MARKETING: {
        SALES: [
            "SELLING_PRICE_DOMESTIC",
        ],
        MARKETING_AND_PRODUCT_DEVELOPMENT: [
            "INVESTMENT_IN_INNOVATION",
            "INVESTMENT_IN_ADVERTISEMENTS",
        ],
        MARKET_RESEARCH: [
            "PURCHASE_MARKET_RESEARCH_AVG_PRICE_LAST_PERIOD",
            "PURCHASE_MARKET_RESEARCH_AVG_DEVELOPMENT_AND_MARKETING_EXPENSES",
            "PURCHASE_MARKET_RESEARCH_SOLD_ITEMS",
            "PURCHASE_MARKET_RESEARCH_GOODS_PRODUCED",
            "PURCHASE_MARKET_RESEARCH_AVG_CASH_FLOW",
        ],
    },
    PRODUCTION: {
        PRODUCTION:  [
            "PLANNED_PRODUCTION_COUNT",
            "FILLING_LINES_PURCHASED",
            "FILLING_LINES_SOLD",
            "PACKING_ROBOTS_PURCHASED",
            "PACKING_ROBOTS_SOLD",
            "PRODUCTION_FACILITIES_PURCHASED",
            "PURCHASE_PRODUCTION_LINE_MAINTENANCE",
        ],
    },
    MATERIEL: {
        MATERIEL: [
            "PURCHASE_CONCENTRATE",
            "PURCHASE_BOTTLES",
            "PURCHASE_BOXES",
        ],
    },
    PERSONNEL: {
        PRODUCTION_WORKERS: [
            "PRODUCTION_WORKER_HIRES",
            "PRODUCTION_WORKERS_LET_GO",
            "PRODUCTION_WORKER_TRAINING_COURSES",
        ],
        SALESMEN: [
            "SALESMEN_HIRES",
            "SALESMEN_LET_GO",
        ],
        PROCUREMENT_SPECIALISTS: [
            "PROCUREMENT_SPECIALIST_HIRES",
            "PROCUREMENT_SPECIALISTS_LET_GO",
        ],
    },
    BANK: {
        LONG_TERM_DEBT: [
          "ADDED_LONG_TERM_DEBT",
          "REPAID_LONG_TERM_DEBT",
        ],
        DEPOSITS: [
          "AMOUNT_DEPOSITED",
          "AMOUNT_WITHDRAWN",
        ],
    },
    INCOME_STATEMENT: {},
};
